import deepCopy from './deepCopy';
import loadImage from './LoadImage';
import textToUrl from './textToUrl';
import hexToRgb from './hexToRgb';
import detectSafariBrowser from './detectSafariBrowser';

export default {
    deepCopy,
    loadImage,
    textToUrl,
    hexToRgb,
    detectSafariBrowser,
};